import React from 'react';
import { RouteIcon } from 'lucide-react';
interface OptimizeRouteButtonProps {
  optimizeRoute: () => void;
}
const OptimizeRouteButton: React.FC<OptimizeRouteButtonProps> = ({
  optimizeRoute
}) => {
  return <button onClick={optimizeRoute} className="w-full flex justify-center items-center px-4 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 font-medium" data-id="element-128">
      <RouteIcon className="w-5 h-5 mr-2" data-id="element-129" />
      Optimize Route
    </button>;
};
export default OptimizeRouteButton;